import { render, staticRenderFns } from "./VectorCoordinateEditor.vue?vue&type=template&id=83e567e0&scoped=true&"
import script from "./VectorCoordinateEditor.vue?vue&type=script&lang=ts&"
export * from "./VectorCoordinateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e567e0",
  null
  
)

export default component.exports